/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ECourseModality } from "../types/ECourseModality.ts";

/**
 * @description 1 = Distance | 2 = Presential | 3 = SemiClassroom | 4 = OnDemand |
 */
export const eCourseModalitySchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = Distance | 2 = Presential | 3 = SemiClassroom | 4 = OnDemand | ",
  ) as unknown as ToZod<ECourseModality>;
